export default defineNuxtPlugin((nuxtApp) => {
  const { $bugsnag } = useNuxtApp()

  if ($bugsnag) $bugsnag.leaveCrumb('last plugin loaded')
  onNuxtReady(() => {
    if ($bugsnag) $bugsnag.leaveCrumb('nuxt ready')
  })
})
